import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_API_URL}/api/employee`;
const sessiData = JSON.parse(sessionStorage.getItem("user"));

const token = sessiData? sessiData[0].token : "";

export const createKaryawan = (data) => {
  return axios.post(`${BASE_URL}/`, data);
};

export const updateKaryawan = (id, formData) => {
  return axios.post(`${BASE_URL}/${id}`, formData);
};

export const deleteKaryawan = (id) => {
  return axios.delete(`${BASE_URL}/${id}`);
};

export const getKaryawan = async () => {
  const response = await axios.get(`${BASE_URL}/`);
  return response.data; 
};

export const getKaryawanById = async (id,periode) => {
  const response = await axios.get(`${BASE_URL}/details/${id}?periode=${periode}`);
  return response.data; 
};


export const dropdownKaryawan = async () => {

  try {
    const response = await axios.get(`${BASE_URL}/drop/down`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Terjadi kesalahan saat login");
    }
  }
};